import { SearchArticle } from '@/common/api/models.pleased';
import { ArticleAutocompleteState } from './model';
import * as Locale from '@/plugins/i18n';

const state: ArticleAutocompleteState = {
  searchHistory: {},
  widgetTitle: '',
};

const mutations = {
  addSearchHistoryItem(
    state: ArticleAutocompleteState,
    payload: { searchHistoryItem: SearchArticle; userId?: number | string }
  ) {
    const { searchHistoryItem, userId } = payload;

    const currentLang = Locale.i18n.locale as Locale.SupportedLanguages;
    const historyKey = `${userId}-${currentLang}`;

    const articlesHistory = state.searchHistory[historyKey];

    if (articlesHistory) {
      // In case this article already in history – remove it
      const articlesHistoryWithoutNewItem = articlesHistory.filter((item) => item.id !== searchHistoryItem.id);
      // Push recently opened article to the top
      const newArticlesHistory = [searchHistoryItem, ...articlesHistoryWithoutNewItem];

      state.searchHistory[historyKey] = newArticlesHistory;
    } else {
      state.searchHistory[historyKey] = [searchHistoryItem];
    }
  },
  setWidgetTitle(state: ArticleAutocompleteState, widgetTitle: string) {
    state.widgetTitle = widgetTitle;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
